import * as React from 'react';
import styled from 'styled-components';
import { WHITE, TURQUOISE } from 'govuk-colours';
import { typography, spacing } from '@govuk-react/lib';
import { BORDER_WIDTH, SPACING_POINTS, MEDIA_QUERIES } from '@govuk-react/constants';
import { stripUnit } from 'polished';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _excluded = ["title", "children"];

var _styled$withConfig;
var RAW_BORDER_WIDTH = Number(stripUnit(BORDER_WIDTH));
var StyledPanel = styled('div').withConfig({
  displayName: "src__StyledPanel",
  componentId: "sc-12tinr5-0"
})(typography.font({
  size: 19
}), (_styled$withConfig = {
  boxSizing: 'border-box',
  marginBottom: SPACING_POINTS[3],
  // NB govuk-frontend has this element styled tablet-first
  padding: SPACING_POINTS[6] - RAW_BORDER_WIDTH,
  border: "".concat(BORDER_WIDTH, " solid transparent"),
  textAlign: 'center'
}, _defineProperty(_styled$withConfig, MEDIA_QUERIES.TABLET, {
  padding: SPACING_POINTS[7] - RAW_BORDER_WIDTH
}), _defineProperty(_styled$withConfig, "color", WHITE), _defineProperty(_styled$withConfig, "background", TURQUOISE), _styled$withConfig), spacing.withWhiteSpace()); // NB govuk-frontend allows for the headingLevel to change, but defaults to h1
// we're not supporting headingLevel at this time

var StyledTitle = styled('h1').withConfig({
  displayName: "src__StyledTitle",
  componentId: "sc-12tinr5-1"
})({
  marginTop: 0,
  marginBottom: SPACING_POINTS[6],
  ':last-child': {
    marginBottom: 0
  }
}, typography.font({
  size: 48,
  weight: 'bold'
}));
var StyledBody = styled('div').withConfig({
  displayName: "src__StyledBody",
  componentId: "sc-12tinr5-2"
})(typography.font({
  size: 36
}));
/**
 * The panel component is a visible container used on confirmation or results pages to highlight important content.
 *
 * - https://govuk-react.github.io/govuk-react/?path=/docs/panel
 * - https://design-system.service.gov.uk/components/panel/
 *
 */

var Panel = function Panel(_ref) {
  var title = _ref.title,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(StyledPanel, props, /*#__PURE__*/React.createElement(StyledTitle, null, title), children && /*#__PURE__*/React.createElement(StyledBody, null, children));
};
Panel.defaultProps = {
  children: undefined
};
Panel.displayName = 'Panel';

export { Panel, Panel as default };
